export const categoryLabelMap: Record<string, string> = {
  CHEMICALS: "Chemicals",
  FABRIC: "Fabric",
};
